// firebase.js
import { initializeApp } from "firebase/app"; // Import initializeApp
import { getDatabase, ref, onChildAdded } from "firebase/database"; // Import Realtime Database functions

// Your Firebase configuration object (replace with your actual config)
const firebaseConfig = {
  apiKey: "AIzaSyBHqwnVZ8UL9wBDeKKzFiqtXvlqPykNN4U",
  authDomain: "salem-ef61f.firebaseapp.com",
  databaseURL: "https://salem-ef61f.firebaseio.com",
  projectId: "salem-ef61f",
  storageBucket: "salem-ef61f.firebasestorage.app",
  appId: "1:877554923083:web:f01200b1935fd44a31bfce",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
const database = getDatabase(app);

export { database, ref, onChildAdded }; // Export necessary functions
